
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

interface FilterOption {
  value: string;
  label: string;
}

interface CharacterStatusFilterProps {
  selectedValue: string;
  onFilterChange: (value: string) => void;
  options: FilterOption[];
  placeholder?: string;
}

export const CharacterStatusFilter = ({
  selectedValue,
  onFilterChange,
  options,
  placeholder = "Filter by status"
}: CharacterStatusFilterProps) => {
  return (
    <div className="w-full lg:w-48">
      <Select value={selectedValue} onValueChange={onFilterChange}>
        <SelectTrigger>
          <SelectValue placeholder={placeholder} />
        </SelectTrigger>
        <SelectContent>
          {options.map((option) => (
            <SelectItem key={option.value} value={option.value}>
              {option.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};
